<template>
  <div class="content-container">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>公告</el-breadcrumb-item>
      <el-breadcrumb-item>公告管理</el-breadcrumb-item>
    </el-breadcrumb>
    <search-former
      @search="searchCallback"
      :date="$route.name == 'notice_history'"
    ></search-former>
    <div class="panel mt-20">
      <el-button
        type="primary"
        size="small"
        icon="el-icon-plus"
        @click="handleNew"
        v-permission="Auth.noticeNew"
        v-if="$route.name == 'notice_manage'"
        >新增公告</el-button
      >
      <el-table
        :data="notices.filter((item) => item.status == filter.status)"
        stripe
        style="width: 100%"
      >
        <el-table-column
          align="left"
          prop="title"
          label="标题"
        ></el-table-column>
        <el-table-column
          align="left"
          prop="notice_category.whole_name"
          label="分类"
        ></el-table-column>
        <!-- <el-table-column
          align="left"
          label="通知对象"
          v-if="auth.isPlatformUser()"
        >
          <template slot-scope="scope">{{
            NoticeCategoryMap[scope.row.category]
          }}</template>
        </el-table-column> -->
        <!-- <el-table-column
          align="left"
          prop="summary"
          label="摘要"
          min-width="120"
        ></el-table-column> -->

        <el-table-column
          align="center"
          label="发布者"
          width="120"
          v-if="$route.name == 'notice_history'"
        >
          <template slot-scope="scope">
            {{ showPublisher(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column
          v-else
          align="center"
          prop="user.name"
          label="创建人"
          width="120"
        ></el-table-column>

        <el-table-column align="center" label="发布时间" width="120">
          <template slot-scope="scope">
            {{ formatTime(scope.row.published_at) }}
          </template>
        </el-table-column>
        <el-table-column align="center" label="状态" width="120">
          <template slot-scope="scope">
            <status-tag
              :type="NoticeStatusMap[scope.row.status].type"
              :name="
                scope.row.status == 3 && scope.row.flow_id
                  ? '审批未通过'
                  : NoticeStatusMap[scope.row.status].name
              "
            ></status-tag>
          </template>
        </el-table-column>
        <el-table-column align="right" label="操作" width="240">
          <template slot-scope="scope">
            <template>
              <el-popconfirm
                v-permission="Auth.noticeDelete"
                title="确认删除吗？"
                @confirm="handleDelete(scope.$index, scope.row.id)"
                v-if="scope.row.status == 3"
              >
                <el-button
                  slot="reference"
                  type="danger"
                  plain
                  size="mini"
                  class="mr-10"
                  >删除</el-button
                >
              </el-popconfirm>
              <el-button
                class="ml-10"
                type="primary"
                plain
                size="mini"
                @click="handleEdit(scope.$index, scope.row)"
                v-if="scope.row.status != 1"
                v-permission="Auth.noticeEdit"
                >编辑</el-button
              >
              <router-link
                :to="
                  '/dashboard/' +
                  stausRouteMap[filter.status] +
                  '/' +
                  scope.row.id
                "
                v-permission="Auth.noticeShow"
              >
                <el-button class="ml-10" type="primary" plain size="mini"
                  >详情</el-button
                >
              </router-link>
            </template>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="mt-20"
        :page-size="filter.size"
        :current-page.sync="filter.page"
        layout="total, prev, pager, next"
        :total="total"
      ></el-pagination>

      <notice-former
        :model="model"
        :show.sync="visible"
        @created="createdCallback"
        @updated="updatedCallback"
      ></notice-former>
    </div>
  </div>
</template>

<script>
import { noticeList, updateNoticeStatus, deleteNotice } from '@/service/getData'
import { clone } from '@/util'
import { isMobile } from '@/util/index'
import NoticeFormer from './former'
import { NoticeCategoryMap, NoticeStatusMap } from '@/config/global'
import SearchFormer from '../search_former'
import auth from '../../../util/auth'
import { formatTime } from '../../../util'

export default {
  components: {
    NoticeFormer,
    SearchFormer,
  },
  data() {
    return {
      auth,
      NoticeCategoryMap,
      NoticeStatusMap,
      formatTime,
      filter: {
        page: 1,
        size: 20,
        status: this.$route.meta.status,
      },
      stausRouteMap: {
        1: 'notice_history',
        2: 'notice_approve',
        3: 'notices',
      },
      total: 0,
      model: {
        id: 0,
        title: '',
        notice_category_id: '',
        summary: '',
        content: '',
        files: [],
      },
      editIndex: 0,
      isMobile,
      notices: [],
      visible: false,
    }
  },
  created() {
    this.getNotices()
  },
  watch: {
    $route(to, from) {
      this.notices = []
      this.filter.page = 1
      this.filter.name = ''
      this.filter.date = []
      this.filter.start_date = ''
      this.filter.end_date = ''
      this.filter.status = to.meta.status
      this.getNotices()
    },
    'filter.page': function () {
      this.getNotices()
    },
  },
  methods: {
    searchCallback(e) {
      this.filter.name = e.name
      this.filter.page = 1
      if (e.date && e.date.length > 0) {
        this.filter.start_date = e.date[0]
        this.filter.end_date = e.date[1]
      } else {
        this.filter.start_date = ''
        this.filter.end_date = ''
      }
      this.getNotices()
    },
    async getNotices() {
      let data = clone(this.filter)
      data.page -= 1
      let res = await noticeList(data)
      if (res.code == 0) {
        this.notices = res.data.list
        this.total = res.data.total
      }
    },
    createdCallback(data) {
      this.notices.unshift(data)
    },
    updatedCallback(data) {
      this.$set(this.notices, this.editIndex, data)
    },
    handleNew() {
      this.model = {
        id: 0,
        title: '',
        notice_category_id: '',
        summary: '',
        content: '',
        files: [],
      }
      this.visible = true
    },
    handleEdit(index, item) {
      this.editIndex = index
      this.model = {
        id: item.id,
        notice_category_id: item.notice_category_id
          ? item.notice_category_id
          : '',
        title: item.title,
        summary: item.summary,
        content: item.content,
        files: item.files || [],
      }
      this.visible = true
    },
    async handleDelete(index, id) {
      let res = await deleteNotice(id)
      if (res.code == 0) {
        this.notices.splice(index, 1)
      }
    },
    showPublisher(notice) {
      if (notice.dealer_id == 0 && !auth.isPlatformUser()) {
        return '平台'
      } else {
        return notice.user.name
      }
    },
  },
}
</script>